/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractFilterOptionsQueryDto
 */
export interface ContractFilterOptionsQueryDto {
    /**
     * 
     * @type {boolean}
     * @memberof ContractFilterOptionsQueryDto
     */
    isMyContract?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ContractFilterOptionsQueryDto
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContractFilterOptionsQueryDto
     */
    endDate?: Date;
}

/**
 * Check if a given object implements the ContractFilterOptionsQueryDto interface.
 */
export function instanceOfContractFilterOptionsQueryDto(value: object): value is ContractFilterOptionsQueryDto {
    return true;
}

export function ContractFilterOptionsQueryDtoFromJSON(json: any): ContractFilterOptionsQueryDto {
    return ContractFilterOptionsQueryDtoFromJSONTyped(json, false);
}

export function ContractFilterOptionsQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractFilterOptionsQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isMyContract': json['isMyContract'] == null ? undefined : json['isMyContract'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
    };
}

export function ContractFilterOptionsQueryDtoToJSON(json: any): ContractFilterOptionsQueryDto {
    return ContractFilterOptionsQueryDtoToJSONTyped(json, false);
}

export function ContractFilterOptionsQueryDtoToJSONTyped(value?: ContractFilterOptionsQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isMyContract': value['isMyContract'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
    };
}

